import { render, staticRenderFns } from "./WorkshopInfoPanel.vue?vue&type=template&id=4c509bd0&scoped=true"
import script from "./WorkshopInfoPanel.vue?vue&type=script&lang=js"
export * from "./WorkshopInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkshopInfoPanel.vue?vue&type=style&index=0&id=4c509bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c509bd0",
  null
  
)

export default component.exports